import React, { createContext, useContext, useState, Dispatch, SetStateAction, useMemo } from 'react';
import { IFilter } from 'pages/InvoiceLetter/CheckOrders';

export interface IFilterContext {
  filter: IFilter | null;
  setFilter: Dispatch<SetStateAction<IFilter | null>>;
}

interface Props {
  children: React.ReactNode;
}

const FilterContext = createContext<IFilterContext | undefined>(undefined);

export const FilterProvider: React.FC<Props> = ({ children }) => {
  const [filter, setFilter] = useState<IFilter | null>(null);

  const contextValue = useMemo(() => ({ filter, setFilter }), [filter]);

  return <FilterContext.Provider value={contextValue}>{children}</FilterContext.Provider>;
};

export const useFilterContext = () => {
  const context = useContext(FilterContext);
  if (!context) {
    throw new Error('useFilterContext must be used within a FilterProvider');
  }
  return context;
};
